function openPopup(button, iframeSrc) {
  const iframe = document.createElement("iframe");
  iframe.setAttribute("src", iframeSrc);
  iframe.setAttribute("title", "YouTube video player");
  iframe.setAttribute("frameborder", "0");
  iframe.setAttribute("allowfullscreen", "");
  iframe.setAttribute(
    "allow",
    "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
  );

  const section = button?.closest("section");
  const popup = section?.querySelector(".popup-wrapper");
  const iframeContainer = popup?.querySelector(".iframe-container");
  const closeButton = popup?.querySelector(".popup-close");

  if (iframeContainer) {
    popup.classList.add("open");
    iframeContainer.innerHTML = "";
    iframeContainer.appendChild(iframe);
  }

  function onFocus(e) {
    if (!popup.contains(e.target)) {
      closeButton.focus();
    }
  }

  function handleEscape(e) {
    if (e.key === "Escape") {
      closePopup(button);
      document.removeEventListener("focusin", onFocus);
      document.removeEventListener("keydown", handleEscape);
      button.focus();
    }
  }

  document.addEventListener("focusin", onFocus);
  document.addEventListener("keydown", handleEscape);
}

function closePopup(button) {
  const section = button?.closest("section");
  const popup = section?.querySelector(".popup-wrapper");
  const iframeContainer = popup?.querySelector(".iframe-container");

  if (iframeContainer) {
    popup.classList.remove("open");
    setTimeout(() => {
      iframeContainer.innerHTML = "";
    }, 500);
  }
}
